/**
 * @file modules/store_modal_hash.js
 * @description Hash deep-link opens the modal named in location.hash, gated
 *              on data-hash-openable — this pack loads on every page, so an
 *              unscoped handler would grant hash-auto-open to every modal
 *              on the site. Click trigger is delegated from document so
 *              markup rendered after load still works.
 */
const OPEN_ATTR = "open";

/**
 * fragno-modal auto-focuses its close button on open with no opt-out —
 * blurred here instead, once it lands, so nothing is focused but Tab still
 * reaches it first. Read via el.shadowRoot: document.activeElement from
 * outside only reports the host, not anything inside its open shadow tree.
 */
function suppressCloseButtonAutoFocus(el) {
  requestAnimationFrame(() => {
    const active =
      (el.shadowRoot && el.shadowRoot.activeElement) || document.activeElement;
    if (active && active.classList.contains("fragno-close-button")) {
      active.blur();
    }
  });
}

function openModal(el) {
  if (!el) return;
  el.addEventListener(
    "fragno-modal-open",
    () => suppressCloseButtonAutoFocus(el),
    { once: true },
  );
  el.setAttribute(OPEN_ATTR, "");
}

function openFromHash() {
  const id = window.location.hash.slice(1);
  if (!id) return;
  const el = document.getElementById(id);
  if (!el || !el.hasAttribute("data-hash-openable")) return;
  openModal(el);
}

function onClick(event) {
  const trigger = event.target.closest("[data-modal-open]");
  if (!trigger) return;

  openModal(document.getElementById(trigger.getAttribute("data-modal-open")));
}

export function initModalHashOpen() {
  openFromHash();
  window.addEventListener("hashchange", openFromHash);
  document.addEventListener("click", onClick);
}

if (typeof document !== "undefined") {
  document.addEventListener("DOMContentLoaded", initModalHashOpen);
}
